import Checkbox from './checkbox';
import './styles.css';

export default function CheckboxesGroup({
  items,
  selectedValues,
  onSelect,
  prefix = 'instructor-onboarding'
}) {
  return (
    <div className="onboarding-checkboxes-container">
      {
        items.map((item, index) => {
          return (
            <Checkbox
              key={`${prefix}-${index}`}
              isChecked={selectedValues?.some(selectedGameType => selectedGameType === item.id)}
              label={item.label}
              onCheck={() => 
                onSelect({ type: item.id })
              }
              title={item.label}
            />
          )
        })
      }
    </div>
  );
}